import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const benefitKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'benefits'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'benefits', itemId] as const,
        detail: [...keys, 'benefits', itemId, 'detail'] as const,
      }),
    export: [...keys, 'export'] as const,
  });

export { benefitKeys };
